export default __webpack_public_path__ + "static/media/Ham.cd5dd7be.svg";